import * as React from 'react';
import axios from 'axios';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Button from '@mui/material/Button';
import Session from '../components/chirotoSession';
import Song from '../components/chirotoSong';

interface SingleSong {
  sections: any[];
}

interface SongData {
  [key: string]: SingleSong;
}

class Chiroto extends React.Component {
  state = {
    songs: {} as SongData,
    songTitles: [] as string[],
    sessions: [] as any[],
    count: 3 as number,
    sort: "session" as string
  }

  componentDidMount() {
    const API_URL = process.env.REACT_APP_API_URL;
    
    // Fetch list of data sorted by session
    axios.get(`${API_URL}/api/sessions/`)
    .then((response: any) => {
      this.setState({ sessions: response.data });
    })
    .catch((err: any) => {
      debugger
    })

    // Fetch dictionary of data organized by song
    axios.get(`${API_URL}/api/songs/`)
    .then((response: any) => {
        const songs = response.data;
        // console.log(`songs: ${JSON.stringify(songs)}`);
        const songTitles = Object.keys(songs);
        this.setState({songs, songTitles});
      })
    .catch((err: any) => {
      debugger
    })
  }

  handleSort = (event: React.MouseEvent<HTMLElement>, value: string | null) => {
    this.setState({ sort: value });
  };

  handleViewMoreClick = () => {
    let {count, sessions} = this.state;
    count = Math.min(count + 2, sessions.length);
    this.setState({ count: count });
  };

  render() {
    let {songs, songTitles, sessions, count, sort} = this.state;
    sessions = sessions.slice(0, count);
    let song: SingleSong = {sections: []};
    if (sort !== "session") song = songs[sort];

    return (<div style={{margin: "2em 2em"}}>
      <h1>Chiroto</h1>

      <div style={{display: "inline"}}>
        View:&nbsp;&nbsp;
        <ToggleButtonGroup
          value={this.state.sort}
          exclusive
          onChange={this.handleSort}
          aria-label="sort-by"
        >
          <ToggleButton value="session" aria-label="session">
            Sessions
          </ToggleButton>
          {songTitles.map((songName: string, id: any) =>  (
            <ToggleButton value={songName} aria-label={songName}>
              {songName}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </div>

      <div style={{margin: "2em 0"}}>
        {sort === "session" ? sessions.map((sessionData: any, id: any) =>  (
          <Session
            key={id}
            date={sessionData.date}
            songs={[]} 
            videos={sessionData.videos}
          />
        )) : <Song
          key={sort}
          title={sort}
          sections={song? song.sections : []}
        />
        }

        {sort === "session" ? <Button
            variant="outlined"
            onClick={this.handleViewMoreClick}
          >View more</Button> : null
        }
      </div>
    </div>);}
}
 
export default Chiroto;